import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

interface HumanizeState {
    isHumanizing: boolean;
    isHumanizingDone: boolean;
    showHumanizeContent: boolean;
    showOriginalContent: boolean;
    isHumanized: boolean;
    isCopyContent: boolean;
    isDownloadContent: boolean;
}

const initialState: HumanizeState = {
    isHumanizing: false,
    isHumanizingDone: false,
    showHumanizeContent: false,
    showOriginalContent: false,
    isHumanized: false,
    isCopyContent: false,
    isDownloadContent: false,
};

export const humanize = createSlice({
    name: 'humanize',
    initialState,
    reducers: {
        setHumanizing: (state, action) => {
            state.isHumanizing = action.payload;
        },
        setHumanizingDone: (state, action) => {
            state.isHumanizingDone = action.payload;
        },
        setShowHumanizeContent: (state, action) => {

            state.showHumanizeContent = action.payload;
        },
        setShowOriginalContent: (state, action) => {
            state.showOriginalContent = action.payload;
        },
        setIsHumanized: (state, action) => {
            state.isHumanized = action.payload;
        },
        setIsCopyContent: (state, action) => {
            state.isCopyContent = action.payload;
        },
        setIsDownloadContent: (state, action) => {
            state.isDownloadContent = action.payload;
        },
    },
});

export const { setHumanizing, setHumanizingDone, setShowHumanizeContent, setShowOriginalContent, setIsHumanized, setIsCopyContent, setIsDownloadContent } = humanize.actions;

export const selectIsHumanizing = (state: RootState) => state.humanize.isHumanizing;
export const selectIsHumanizingDone = (state: RootState) => state.humanize.isHumanizingDone;
export const selectShowHumanizeContent = (state: RootState) => state.humanize.showHumanizeContent;
export const selectShowOriginalContent = (state: RootState) => state.humanize.showOriginalContent;
export const selectIsHumanized = (state: RootState) => state.humanize.isHumanized;
export const selectIsCopyContent = (state: RootState) => state.humanize.isCopyContent;
export const selectIsDownloadContent = (state: RootState) => state.humanize.isDownloadContent;


export default humanize.reducer;